<template>
  <div>
    <img src="../../assets/images/zhejiang/banner.png" class="banner" alt />
    <div class="content">
      <van-search v-model="value" placeholder="请输入搜索关键词" style="padding:0;border-radius:6px;" />
      <div style="font-size:11px;color:white;">平均分为专家已打分的实时统计平均值，最终分数为投票截止后所有打分去掉一个最高分和一个最低分后平均得分</div>
      <div class="list">
        <div class="item-wrap" v-for="item in filterList" :key="item.id">
          <div class="item fx-row fx-row-center" @click="vote(item)">
            <img :src="item.cover" class="item-cover" alt />
            <div>
              <div class="title">{{item.title}}</div>
              <div class="score score1">专家打分(平均分): {{item.zhuanjia}}</div>
              <!-- <div class="score score2">投票数: {{item.vote_count}}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      value: "",
      list: []
    };
  },
  computed: {
    filterList() {
      if (!this.value) {
        return this.list;
      }
      return this.list.filter(item => {
        if (item.title.indexOf(this.value) !== -1) {
          return true;
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.checkPass();
    this.getList();
  },
  methods: {
    checkPass() {
      if (!this.$store.state.customization.zhejiangPass) {
        this.$router.replace({ name: "jinrongtoupiao" });
      }
    },
    getList() {
      this.$reqGet("api/customization/zhejiang_jinrong/voteList").then(res => {
        this.list = res.data.data;
      });
    },
    vote(item){
      this.$router.push({name:'jinrongtoupiao_vote',params:{id:item.id}})
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  display: block;
  width: 100%;
}
.content {
  background: #c30000;
  padding: 15px;
}
.item-wrap {
  margin-top: 10px;
  border-radius: 6px;
  background: white;
  padding: 15px;
  .title {
    font-size: 16px;
  }
  .score {
    color: #c30000;
    font-size: 14px;
  }
}
.item-cover {
  width: 80px;
  height: 80px;
  display: block;
  margin-right: 10px;
}
</style>